export namespace PromiseUtils {
  export interface QuerablePromise<T> extends Promise<T> {
    isFulfilled: () => boolean;
    isPending: () => boolean;
    isRejected: () => boolean;
  }

  export function isQuerable<T>(input: any): input is QuerablePromise<T> {
    return Promise.resolve(input) === input && input.isResolved !== undefined;
  }

  export function makeQuerable<T>(promise: Promise<T> | QuerablePromise<T>): QuerablePromise<T> {
    // Don't modify any promise that has been already modified.
    if (isQuerable(promise)) {
      if (promise.isPending) {
        return promise;
      }
    }

    // Set initial state
    let isPending = true;
    let isRejected = false;
    let isFulfilled = false;

    // Observe the promise, saving the fulfillment in a closure scope.
    const result: QuerablePromise<T> = promise.then(
      v => {
        isFulfilled = true;
        isPending = false;
        return v;
      },
      e => {
        isRejected = true;
        isPending = false;
        throw e;
      }
    ) as any;

    result.isFulfilled = () => isFulfilled;
    result.isPending = () => isPending;
    result.isRejected = () => isRejected;
    return result;
  }

  export function wait(time: number = 0): Promise<void> {
    return new Promise(resolve => {
      window.setTimeout(() => {
        resolve();
      }, time);
    });
  }

  export const nextTick = () => wait();
}



// WEBPACK FOOTER //
// ./src/module/Common/utils/PromiseUtils.ts